import iziToast from "izitoast";
import Vue from "vue";
import VueNotifications from "vue-notifications";

import "../../node_modules/izitoast/dist/css/iziToast.min.css";

/**
 * iziToast docs: http://izitoast.marcelodolce.com/
 * Vue Notifications: https://se-panfilov.github.io/vue-notifications/docs/html/usage.html
 */
function toast(params) {
  // iziToast and Vue-notifications differ on their warn/warning data contract
  if (params.type === VueNotifications.types.warn) {
    params.type = "warning";
  }

  // Sets default position
  if (!params.position) params.position = "topRight";

  // Set default icons by type if not explicitly set
  if (!params.icon) {
    if (params.type === "success") {
      params.icon = "fas fa-check-circle";
    } else if (params.type === "info") {
      params.icon = "fas fa-info-circle";
    } else {
      params.icon = "fas fa-exclamation-triangle";
    }
  }

  return iziToast[params.type](params);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
};

Vue.prototype.$notifyError = params => {
  const notificationsParams = Object.assign({}, params, {
    type: "error",
    title: "Error",
  });
  toast(notificationsParams);
};

Vue.prototype.$notifyInfo = params => {
  const notificationsParams = Object.assign({}, params, {
    type: "info",
  });
  toast(notificationsParams);
};

Vue.prototype.$notifySuccess = params => {
  const notificationsParams = Object.assign({}, params, {
    type: "success",
    title: "Success",
  });
  toast(notificationsParams);
};

Vue.prototype.$notifyWarn = params => {
  const notificationsParams = Object.assign({}, params, {
    type: "warn",
    title: "Warning",
  });
  toast(notificationsParams);
};

Vue.use(VueNotifications, options);
